import { useRef } from 'react';
import { Modal } from './Modal';
import { toast } from './Toast';

type ExportCsvModalProps = {
  name: string;
  csv: string;
  onClose: () => void;
};

export function ExportCsvModal({ name, csv, onClose }: ExportCsvModalProps) {
  const areaRef = useRef<HTMLTextAreaElement>(null);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(csv);
      toast('CSV скопирован в буфер обмена. Вставьте его в Excel или Google Sheets.', 'ok');
    } catch {
      areaRef.current?.select();
      toast('Не удалось скопировать автоматически. Текст уже выделен — нажмите Ctrl+C, чтобы скопировать его.', 'err');
    }
  };

  return (
    <Modal
      title={`Экспорт · ${name}`}
      wide
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn" data-close onClick={onClose}>
            Закрыть
          </button>
          <button type="button" className="btn btn-primary" id="csvCopy" onClick={() => void copy()}>
            Скопировать
          </button>
        </>
      }
    >
      <textarea id="csvOut" rows={10} readOnly value={csv} ref={areaRef} />
    </Modal>
  );
}
